import axios from 'axios';
import Loading from 'components/common/Loading'
import React, { useCallback, useEffect, useState } from 'react'
import { Cookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { insertAllowPageInfo } from 'redux/slices/allowPageSlice';
import { insertUserInfo } from 'redux/slices/userSlice';

function Demo() {
    //state
    const [init, setInit] = useState(true);
    //dispatch
    const dispatch = useDispatch();
    //navigate
    const navigate = useNavigate();
    //env
    const authNm = process.env.REACT_APP_AUTH_TOKEN;
    const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
    const domain = process.env.REACT_APP_DOMAIN;

    const loginHandler = useCallback(() => {
        axios.get("/user/demo")
            .then(
                res => {
                    if (res.status === 200) {
                        const memeberInfo = res.data.MEMBER_INFO;
                        const cookies = new Cookies();

                        cookies.set(
                            authNm,
                            memeberInfo.AUTH_TOKEN,
                            {
                                path: "/",
                                domain: domain
                            }
                        );

                        cookies.set(
                            refreshNm,
                            memeberInfo.REFRESH_TOKEN,
                            {
                                path: "/",
                                maxAge: null,
                                domain: domain
                            }
                        );

                        dispatch(
                            insertUserInfo({
                                name: memeberInfo.MEMBER_NM,
                                id: memeberInfo.MEMBER_ID
                            })
                        );

                        const allowPages = res.data.ALLOW_PAGES;

                        dispatch(insertAllowPageInfo({ pages: allowPages }));
                        navigate(
                            process.env.REACT_APP_CLIENT_URL + "app/meeting/calendar",
                            { state: { isMenuOpen: false } }
                        );
                    }
                }
            )
            .catch(() => {
                navigate(process.env.REACT_APP_CLIENT_URL);
            })
    }, [authNm, dispatch, domain, navigate, refreshNm]);

    useEffect(
        () => {
            if (init) {
                loginHandler();
                setInit(false);
            }
        }, [init, loginHandler]
    );


    return (
        <Loading />
    )
}

export default Demo
